const nonAlphaNumeric = /[^a-zA-Z0-9 ]/g;
const nonNumeric = /[^0-9]/g;

export default {
  GB: { forbiddenCharacters: nonAlphaNumeric, maxLength: 8 },
  US: { forbiddenCharacters: nonNumeric, maxLength: 5 },
};
